// extracted by mini-css-extract-plugin
export default {"progress-bar":"beam-progress-bar_progress-bar__8nBYS"};